import React, { useCallback } from 'react';
import { ListCarousel, DashboardCourseCard } from '../../../ui';
import { useNavigate } from 'react-router';
import { useFeatures } from '../../settings/hooks';

const CoursesListCarousel = ({ courses, header, headerRight, navColor }) => {

  const navigate = useNavigate();
  const features = useFeatures();

  const goToCourse = useCallback((item) => {
    navigate(`/view/course/${item.id}`)
  }, [navigate]);

  const goToEdit = useCallback((item) => {
    if (features?.modernCourseBuilder) {
      navigate(`/edit/course/${item.id}`);
    } else {
      navigate(`/course/${item.ownerSlug}/${item.slug}`, { state: item });
    }
  }, [navigate, features]);

  const goToCourseSettings = useCallback((item) => {
    navigate(`/courses/${item.id}/settings`);
  }, [navigate]);

  return (
    <ListCarousel header={header} headerRight={headerRight} navColor={navColor}>
      {courses.map((item, index) =>
        <DashboardCourseCard
          draftCourses={features?.draftCourses}
          key={`course-card${item.id}-${index}`}
          courseInfo={item}
          goToCoursePage={goToCourse}
          goToSettings={goToCourseSettings}
          goToEditCourse={goToEdit}
        />
      )}
    </ListCarousel>
  );
};

export default CoursesListCarousel;
